"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncValidate = exports.isSyncTransform = void 0;
exports.isSyncTransform = function (transform) {
  return transform.length === 1;
};
exports.isSyncValidate = function (validate) {
  return validate.length === 1;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBb0JhQSx1QkFBZSxHQUFHLFVBQzNCQyxTQUFxQztFQUFBLE9BQ0NBLFNBQVMsQ0FBQ0MsTUFBTSxLQUFLLENBQUM7QUFBQTtBQVFuREYsc0JBQWMsR0FBRyxVQUFnQkcsUUFBd0I7RUFBQSxPQUNsRUEsUUFBUSxDQUFDRCxNQUFNLEtBQUssQ0FBQztBQUFBIiwibmFtZXMiOlsiZXhwb3J0cyIsInRyYW5zZm9ybSIsImxlbmd0aCIsInZhbGlkYXRlIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==